module.exports = __webpack_public_path__ + "static/media/5-2.b66588c8.webp";